import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Small floating "arc-reactor" shortcut to the super-admin console (visible only to super_admin).
export function AdminFab() {
  const { user } = useAuth();
  if (!user || user.role !== "super_admin") return null;
  return (
    <Link to="/admin" title="Console Admin" aria-label="Console Admin" data-testid="admin-fab"
      className="fixed bottom-5 right-5 z-[9998] group">
      <span className="arc-reactor" />
    </Link>
  );
}
